(function() {
    const copyClipboardBtns = document.querySelectorAll('.jsCopyClipboardLink');
    for (let i = 0; i < copyClipboardBtns.length; i++) {
        new ClipboardJS(copyClipboardBtns[i], { text: _ => {
            copyClipboardBtns[i].innerHTML = 'Copied!';
            setTimeout(_ => copyClipboardBtns[i].innerHTML = 'Copy link', 3000);
            return copyClipboardBtns[i].dataset.copyUrl;
        } });
    }
})();